import React from 'react';
import { AiOutlineCheckCircle, AiOutlineCloseCircle } from 'react-icons/ai';

const IconTrueOrFalse = ({ value, trueColor, falseColor }) =>
    value ? (
        <AiOutlineCheckCircle
            style={{
                fontSize: '16pt',
                color: `${trueColor || 'green'}`,
            }}
        />
    ) : (
        <AiOutlineCloseCircle
            style={{
                fontSize: '16pt',
                color: `${falseColor || 'black'}`,
            }}
        />
    );

export default IconTrueOrFalse;
